import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=1a129373&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"
import style0 from "./pages.vue?vue&type=style&index=0&id=1a129373&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a129373",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a129373')) {
      api.createRecord('1a129373', component.options)
    } else {
      api.reload('1a129373', component.options)
    }
    module.hot.accept("./pages.vue?vue&type=template&id=1a129373&scoped=true", function () {
      api.rerender('1a129373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/admin/pages.vue"
export default component.exports